let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("256dS")).then(() => parcelRequire('2WBzr'));